import { BehaviorSubject } from 'rxjs';
import { handleResponse } from './handleResponse';

const currentUserSubject = new BehaviorSubject(JSON.parse(sessionStorage.getItem('currentUser')));

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value }
};

function login(username, password, code) {
    let url = code === "" ? "/Account/authenticate" : "/Account/authorize";
    url = process.env.PUBLIC_URL + url;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: code === "" ? JSON.stringify({ username, password }) : JSON.stringify({ code })
    };

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(user => {
            sessionStorage.removeItem('currentUser');
            // store user details and jwt token in session storage to keep user logged in between page refreshes
            sessionStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        });
}

function logout(offline) {
    if (offline === "0") {
        let userName = currentUserSubject.value.Username ? currentUserSubject.value.Username : "";
        let url = process.env.PUBLIC_URL + '/Account/signOut';

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userName })
        };

        fetch(url, requestOptions)
            .then(handleResponse)
            .then(user => {
                // remove user from session storage to log user out
                sessionStorage.removeItem('currentUser');
                currentUserSubject.next(null);
            });
    }
}
